import React from 'react';

import type { InitialData } from './types';

import { DeferredClientEffects } from './effects/DeferredClientEffects';
import LandingExperience from './page/LandingExperience';

export function App({ initialData }: { initialData: InitialData }) {
    React.useEffect(() => {
        if (typeof window === 'undefined') return;

        const startReveal = () => {
            if (!window.matchMedia('(min-width: 768px)').matches) {
                for (const element of Array.from(document.querySelectorAll<HTMLElement>('[data-reveal]'))) {
                    element.classList.add('is-revealed');
                }

                // No scroll reveal on mobile, but ambient loops must still
                // pause off-screen and while the tab is hidden.
                void import('./lib/reveal').then(({ initMotionPausing }) => {
                    initMotionPausing();
                });

                return;
            }

            void import('./lib/reveal').then(({ initScrollReveal }) => {
                initScrollReveal();
            });
        };

        const requestIdleCallback = window.requestIdleCallback?.bind(window);
        const cancelIdleCallback = window.cancelIdleCallback?.bind(window);

        if (requestIdleCallback && cancelIdleCallback) {
            const idleId = requestIdleCallback(() => startReveal(), { timeout: 1200 });

            return () => cancelIdleCallback(idleId);
        }

        let timeoutId: number | null = window.setTimeout(() => startReveal(), 250);

        return () => {
            if (timeoutId === null) return;
            window.clearTimeout(timeoutId);
            timeoutId = null;
        };
    }, []);

    return (
        <div class="min-h-screen">
            <DeferredClientEffects />
            <LandingExperience initialData={initialData} />
        </div>
    );
}
